const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'UNIDADE_MEDIDA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'UNIDADE_MEDIDA_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'UNIDADE_MEDIDA_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.sigla
                }))
            };

        default:
            return state;
    }
}
